import axios from 'axios';
// import QS from 'qs';  //序列化请求
import methodsToken from './api.js';
import storage from "../utils/storage";
import routerIndex from "../router";
import {apiBaseUrl} from './env';
import { Message } from "element-ui";
axios.defaults.baseURL = apiBaseUrl;

//配置请求头
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers.post['Content-Type'] = 'application/json; charset=utf-8';
export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    }).then(res => {
      resolve(res.data);
    }).catch(err => {
      reject(err.data)
    })
  });
}
export function post(method, params = {}) {
  if (methodsToken.indexOf(method) >= 0) {
    let userToken = storage.get("userToken");
    if (!userToken || userToken == '') {
      routerIndex.push('/login')
    } else {
      params.token = userToken;
    }
  }
  params.method = method;
  return new Promise((resolve, reject) => {
    axios.post('api.html', params)
      .then(res => {
        const result = res.data;
        if (!result.status) {
          // 登录信息过期或者未登录
          // Message({
          //   showClose: true,
          //   message: result.msg,
          //   type: 'error',
          //   duration: 1500
          // })
          if (result.data === 14007 || result.data === 14006) {
            storage.remove("userToken");
            routerIndex.push('/login')
          }
        }
        resolve(result);
      })
      .catch(err => {
        if (err && err.response) {
          Message({
            showClose: true,
            message: err.response,
            type: 'error',
            duration: 1500
          })
          // reject(err.response)
        }
      })
  });
}
//上传文件
export const uploadImage = (url, data) => {
  return new Promise((resolve, reject) => {
    data.append('method', 'images.upload')
    data.append('token', window.localStorage.getItem("userToken"))

    axios.post(url, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    }).then(res => {
      resolve(res.data);
    }).catch(err => {
      reject(err.data)
    })
  });
}
// 获取商品分类

//顶部底部导航
export const shopMenu = p => get(apiBaseUrl + '/plugins/pc-api-getMenu.html', p);
//首页楼层
export const homeLoftData=p=>get(apiBaseUrl+'/plugins/pc-api-getFloor.html',p);

export const distributionCenter=p=>get(apiBaseUrl+'/plugins/distribution_center-api-info.html',p);

// 推广中心推广的订单
export const distributionOrder=p=>get(apiBaseUrl+'/plugins/distribution_center-api-myorder.html',p);


// 获取店铺配置
// export const shopConfig = p => get(apiBaseUrl + '/api/common/jshopconf', p);

export const shopConfig = p => post('common.jshopconf', p);



// export const shopConfig = (data, callback) => post('common.jshopconf', data,  callback);


// 用户注册
export const reg = p => post('user.reg', p);

// 用户登录
export const login = p => post('user.login', p);

// 用户信息
export const userInfo = p => post('user.info', p);

// 上传头像
export const changeAvatar = p => post('user.changeavatar', p);

// 编辑用户信息
export const editInfo = p => post('user.editinfo', p);

// 发送短信验证码
export const sms = p => post('user.sms', p);

// 短信验证码登录
export const smsLogin = p => post('user.smslogin', p);

// 退出登录
export const logout = p => post('user.logout', p);

// 获取首页幻灯片
export const slider = p => post('advert.getAdvertList', p);

// 获取公告列表
export const notice = p => post('notice.noticeList', p);

// 获取公告详情
export const noticeInfo = p => post('notice.noticeInfo', p);

// 获取文章详情
export const articleInfo = p => post('articles.getArticleDetail', p);

// 获取文章列表
export const articleList = p => post('articles.getArticleList', p);
//获取文章分类列表
export const articleTypeList = p => post('articles.getArticleType', p);
//获取文章推荐
export const articleRecommend = p => post('articles.leftarticletype', p);

// 获取商品分类
export const categories = p => post('categories.getallcat', p);

// 获取商品列表
export const goodsList = p => post('goods.getlist', p);

// 获取商品详情
export const goodsDetail = p => post('goods.getdetial', p);

// 获取商品参数信息
export const goodsParams = p => post('goods.getgoodsparams', p);

// 获取设置默认货品
export const getProductInfo = p => post('goods.getproductinfo', p);

// 获取商品评论信息
export const goodsComment = p => post('goods.getgoodscomment', p);

// 添加购物车
export const addCart = p => post('cart.add', p);

// 移除购物车
export const removeCart = p => post('cart.del', p);

// 获取购物车列表
export const cartList = p => post('cart.getlist', p);

// 设置购物车商品数量
export const setCartNum = p => post('cart.setnums', p);

// 获取购物车数量
export const getCartNum = p => post('cart.getnumber', p);

// 获取用户的收货地址列表
export const userShip = p => post('user.getusership', p);

// 获取用户默认收货地址
export const userDefaultShip = p => post('user.getuserdefaultship', p);

// 存储用户收货地址
export const saveUserShip = p => post('user.vuesaveusership', p);

// 获取收货地址详情
export const shipDetail = p => post('user.getshipdetail', p);

// 收货地址编辑
export const editShip = p => post('user.editship', p);

// 收货地址删除
export const removeShip = p => post('user.removeship', p);

// 设置默认收货地址
export const setDefShip = p => post('user.setdefship', p);


// 获取发票列表
export const myinvoIcelist = p => post('user.myinvoicelist', p);

// 生成订单
export const createOrder = p => post('order.create', p);

// 获取状态订单列表
export const getOrderList = p => post('order.getlist', p);

// 取消订单
export const cancelOrder = p => post('order.cancel', p);

// 删除订单
export const delOrder = p => post('order.del', p);

// 获取订单详情
export const orderDetail = p => post('order.details', p);

// 确认收货
export const confirmOrder = p => post('order.confirm', p);

// 获取配送方式
export const orderShip = p => post('order.getship', p);

// 获取全部订单列表
export const orderList = p => post('order.getorderlist', p);

// 获取订单不同状态的数量
export const getOrderStatusSum = p => post('order.getorderstatusnum', p);

// 售后单列表
export const afterSalesList = p => post('order.aftersaleslist', p);

// 售后单详情
export const afterSalesInfo = p => post('order.aftersalesinfo', p);

// 订单售后状态
export const afterSalesStatus = p => post('order.aftersalesstatus', p);

// 添加售后单
export const addAfterSales = p => post('order.addaftersales', p);

// 用户发送退货包裹
export const sendShip = p => post('order.sendreship', p);

// 添加商品浏览足迹
export const addGoodsBrowsing = p => post('user.addgoodsbrowsing', p);

// 删除商品浏览足迹
export const delGoodsBrowsing = p => post('user.delgoodsbrowsing', p);

// 获取商品浏览足迹
export const goodsBrowsing = p => post('user.goodsbrowsing', p);

// 商品收藏 关注/取消
export const goodsCollection = p => post('user.goodscollection', p);

// 获取商品收藏关注列表
export const goodsCollectionList = p => post('user.goodscollectionlist', p);

// 获取店铺支付方式列表
export const paymentList = p => post('payments.getlist', p);

// 获取支付单详情
export const paymentInfo = p => post('payments.getinfo', p);

// 支付接口
export const pay = p => post('user.pay', p);

// 订单评价接口
export const orderEvaluate = p => post('user.orderevaluate', p);

// 判断是否签到
export const isSign = p => post('user.issign', p);

// 签到接口
export const sign = p => post('user.sign', p);

// 我的X币
export const myPoint = p => post('user.mypoint', p);

// X币记录
export const pointLog = p => post('user.userpointlog', p);

// 物流信息接口
export const logistics = p => post('order.logisticbyapi', p);

// 优惠券列表
export const couponList = p => post('coupon.couponlist', p);

// 优惠券详情
export const couponDetail = p => post('coupon.coupondetail', p);

// 用户领取优惠券
export const getCoupon = p => post('coupon.getcoupon', p);

// 用户已领取的优惠券列表
export const userCoupon = p => post('coupon.usercoupon', p);

// 获取店铺设置
export const getSetting = p => post('user.getsetting', p);

// 获取商户配置信息
export const getSellerSetting = p => post('user.getsellersetting', p);

// 获取我的银行卡列表
export const getBankCardList = p => post('user.getbankcardlist', p);

// 获取默认的银行卡
export const getDefaultBankCard = p => post('user.getdefaultbankcard', p);

// 添加银行卡
export const addBankCard = p => post('user.addbankcard', p);

// 删除银行卡
export const removeBankCard = p => post('user.removebankcard', p);

// 设置默认银行卡
export const setDefaultBankCard = p => post('user.setdefaultbankcard', p);

// 获取银行卡信息
export const getBankCardInfo = p => post('user.getbankcardinfo', p);

// 获取银行卡组织信息
export const getBankCardOrganization = p => post('user.getbankcardorganization', p);

// 用户修改密码
export const editPwd = p => post('user.editpwd', p);

// 用户找回密码
export const forgotPwd = p => post('user.forgetpwd', p);

// 获取用户余额明细
export const getBalanceList = p => post('user.balancelist', p);

// 用户推荐列表
export const recommendList = p => post('user.recommend', p);

// 邀请码
export const shareCode = p => post('user.sharecode', p);

// 用户提现
export const userToCash = p => post('user.cash', p);

// 用户提现列表
export const cashList = p => post('user.cashlist', p);

// 获取授权登录方式
export const getTrustLogin = p => post('user.gettrustlogin', p);

// 绑定授权登录
export const trustBind = p => post('user.trustbind', p);

// 获取用户信息
export const trustLogin = p => post('user.trustcallback', p);

// 判断用户下单可以使用多少X币
export const usablePoint = p => post('user.getuserpoint', p);

// 门店列表
export const storeList = p => post('store.getstorelist', p);

// 判断是否开启门店自提
export const switchStore = p => post('store.getstoreswitch', p);

// 获取默认的门店
export const defaultStore = p => post('store.getdefaultstore', p);

// 判断是否开启X币
export const isPoint = p => post('user.ispoint', p);

// 用户输入code领取优惠券
export const couponKey = p => post('coupon.getcouponkey', p);

// 判断是否是店员
export const isStoreUser = p => post('store.isclerk', p);

// 获取店铺提货单列表
export const storeLadingList = p => post('store.storeladinglist', p);

// 获取提货单详情
export const ladingInfo = p => post('store.ladinginfo', p);

// 店铺提单操作
export const ladingExec = p => post('store.lading', p);

// 提货单删除
export const ladingDel = p => post('store.ladingdel', p);

// 获取活动列表
export const activityList = p => post('group.getlist', p);

// 获取活动详情
export const activityDetail = p => post('group.getgoodsdetial', p);
//取搜索页推荐关键字
export const getRecommendKeys = p => post('store.getrecommendkeys', p);
//取下级地址列表
export const getAreaList = p => post('user.getarealist', p);
//推荐更多商品
export const getPickGoods = p => post('goods.getpickgoods', p);

// 获取默认选中购物车列表全部信息
export const cartListSelectAll = p => post('cart.getlistselectall', p);

// 获取销售排行榜
export const getSalesRanking = p => post('goods.salesRanking', p);


// 箭馆分类
export const getclublist = p => post('club.getclublist', p);
// 箭馆列表
export const clublist = p => post('club.getlist', p);

// 箭馆详情
export const clubdetail = p => post('club.getdetail', p);


// 加盟 箭馆申请

export const clubjoin = p => post('club.join', p);

// 收藏
export const clubcollection = p => post('club.clubcollection', p);

// 收藏列表
export const collectionlist = p => post('club.collectionlist', p);

// 地址转坐标
export const coordinatemap = p => post('common.coordinatemap', p);

// 智能表单提交
export const formAddsubmit = p => post('form.addsubmit', p);


// 视频列表
export const courseGetlist = p => post('course.getlist', p);

// 视频详情
export const courseGetdetail = p => post('course.getdetail', p);

// 视频评论列表
export const courseGetcoursecomment = p => post('course.getcoursecomment', p);

// 视频评论操作
export const courseCourseevaluate = p => post('course.courseevaluate', p);

// 视频卡列表
export const getcoursecard = p => post('course.getcoursecard', p);

// 查看视频权限
export const coursecheckcourse = p => post('course.checkcourse', p);

// 设置播放记录
export const coursesetlog = p => post('course.setlog', p);

// 购买视频
export const coursepay = p => post('course.pay', p);

// 查询视频订单
export const courseGetorderlist = p => post('course.getorderlist', p);


// 视频分类 类型的数据
export const getcourselist = p => post('course.getcourselist', p);

// 视频分类列表
export const gettypetist = p => post('course.gettypetist', p);


// 相关视频
export const getrelevant = p => post('course.getrelevant', p);


// 新闻分类
export const getnewstype = p => post('news.getnewstype', p);

// 新闻列表
export const newgetlist = p => post('news.getlist', p);


// 新闻详情
export const newgetdetail = p => post('news.getdetail', p);

// 新闻评论
export const courseevaluate = p => post('news.courseevaluate', p);

// 新闻评论列表
export const newsgetcoursecomment = p => post('news.getcoursecomment', p);

// 相关商品
export const relatedgoods = p => post('goods.relatedgoods', p);

// 渠道商员工列表
export const getstafflists = p => post('channelbusiness.getstafflist', p);
// 渠道商信息
export const channelbusinessGetInfo = p => post('channelbusiness.getinfo', p);

// 渠道商 推广订单
export const channelbusinessGetorder = p => post('channelbusiness.getorder', p);

// 添加支付宝账号
export const addalipay = p => post('user.addalipay', p);

// 获取支付宝账号列表
export const getalipaylist = p => post('user.getalipaylist', p);

// 箭馆地址

export const getclubarealist = p => post('user.getclubarealist', p);

// 箭馆审核状态
export const clubStatus = p => post('club.getclub', p);


// 获取商品规格
export const getproductbysku = p => post('goods.getproductbysku', p);

// 渠道类型列表
export const getusergrade = p => post('channelbusiness.getusergrade', p);

// 渠道商编辑员工信息
export const savestaff = p => post('channelbusiness.savestaff', p);


// 渠道商添加员工
export const addstaff = p => post('channelbusiness.addstaff', p);


// 渠道商员工详情
export const getstaffinfo = p => post('channelbusiness.getstaffinfo', p);


// 渠道商员工详情
export const delstaff = p => post('channelbusiness.delstaff', p);

// 员工订单
export const stafforders = p => post('channelbusiness.stafforder', p);

//统一分享
export const share = p => post('user.share', p);


// 渠道商申请
export const channelapply = p => post('channelbusiness.apply', p);

// 渠道商详细信息
export const channelinfo = p => post('channelbusiness.getinfo', p);

// 自定义页面

export const getPageConfig = p => post('pages.getpageconfig', p);
	

// 渠道商提现记录
export const bussinesswithdrawallist = p => post('channelbusiness.bussinesswithdrawallist', p);


// 审核提现
export const examine = p => post('channelbusiness.examine', p);

// 员工提现记录
export const withdrawallist = p => post('channelbusiness.withdrawallist', p);


// 员工提现
export const StaffCash = p => post('channelbusiness.cash', p);

// 赛事列表
export const getList = p => post('game.getlist', p);

// 赛事列表-详情
export const getInfo = p => post('game.getinfo', p);

// 选择参赛人员
export const tagselectinstitutionuser = p => post('game.tagselectinstitutionuser', p);

// 创建赛事报名订单
export const gamePay = (data, callback) => post('game.pay', data, callback);

// 机构编辑
export const describeedit = (data, callback) => post('institution.describeedit', data, callback);

// 机构订单  报名订单
export const getinstitutionorder = (data, callback) => post('game.getinstitutionorder', data, callback);

// 赛事列表-详情-参赛团体
export const getInstitution = (data, callback) => post('game.getinstitution', data, callback);

//比赛平台详情
export const institutionInfo = (data, callback) => post('game.institutioninfo', data, callback);

// 赛事动态
export const getTrendsList = (data, callback) => post('game.gettrendslist', data, callback);

// 实时成绩
export const gatallProject = (data, callback) => post('game.gatallproject', data, callback);

// 比赛排名
export const getallRanking = (data, callback) => post('game.getallranking', data, callback);

//获取支付信息
export const paymentsCheckpay = (data, callback) => post('payments.checkpay', data, callback);

// 赛事动态-详情
export const getTrendsInfo = (data, callback) => post('game.gettrendsinfo', data, callback);

// 练习list
export const planList = (data, callback) => post('examination.planlist', data, callback);

// 练习页item
export const planInfo = (data, callback) => post('examination.planinfo', data, callback);

// 报名考试
export const orderInfo = (data, callback) => post('examination.orderinfo', data, callback);

// 考试题
export const examinaTopicList = (data, callback) => post('examination.examinationopiclist', data, callback);

// 报名考试订单
export const examPay = (data, callback) => post('examination.pay', data, callback);

// 我的成绩
export const achievementList = (data, callback) => post('examination.achievementlist', data, callback);

// 章节练习列表
export const typeList = (data, callback) => post('examination.typelist', data, callback); // 章节练习列表

// 练习题列表
export const practiceTopicList = (data, callback) => post('examination.practicetopiclist', data, callback);

// 练习题提交
export const questionSubmit = (data, callback) => post('examination.questionsubmit', data, callback);

// 练习题收藏
export const questionCollect = (data, callback) => post('examination.questioncollect', data, callback);

// 收藏列表
export const collectList = (data, callback) => post('examination.collectlist', data, callback);

// 收藏习题详情
export const collectTopicList = (data, callback) => post('examination.collecttopiclist', data, callback);

//查看证书
export const certificate = (data, callback) => post('examination.certificate', data, callback);

// 消息中心菜单
export const getMessageMenu = (data, callback) => post('api.getmessagemenu.pushMessage', data, callback);

// 消息中心-消息列表
export const getMessageList = (data, callback) => post('api.getmessgaelist.pushMessage', data, callback);

// 获取秒杀团购
export const getGroup = (data, callback) => post('group.getlist', data, callback);

// 获取秒杀团购详情
export const groupInfo = (data, callback) => post('group.getgoodsdetial', data, callback);




























